// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-page .error-container {
  margin-left: auto;
  margin-right: auto;
  padding-top: 11rem;
  width: 21rem;
  text-align: center;
}
.error-page .error-container img {
  width: 9.5rem;
  height: auto;
  margin-bottom: 3rem;
}
.error-page .error-container h1 {
  font-size: 3rem;
  color: #FF4E35;
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.error-page .error-container h3 {
  font-weight: 200;
  margin-bottom: 0.5rem;
  font-size: 1.3rem;
}
.error-page .error-container h5 {
  font-weight: 100;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
